import { render, staticRenderFns } from "./budgetYearPlan.vue?vue&type=template&id=2afb3426"
import script from "./budgetYearPlan.vue?vue&type=script&lang=js"
export * from "./budgetYearPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afb3426')) {
      api.createRecord('2afb3426', component.options)
    } else {
      api.reload('2afb3426', component.options)
    }
    module.hot.accept("./budgetYearPlan.vue?vue&type=template&id=2afb3426", function () {
      api.rerender('2afb3426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetYearPlan.vue"
export default component.exports